export default __webpack_public_path__ + "static/media/Thumb_Skin_gold.a9c94875.png";